import { api_ai_thread_path, api_ai_threads_path } from '@routes';
import { PageParams, PagedResponse } from '@utils/interfaces';

import request from './request';

const AI_THREADS_KEY = 'AI_THREADS_KEY';

export function getAiThreadsKey(limit?: number) {
  return [AI_THREADS_KEY, limit];
}

export function getAiThreadKey(threadId: string) {
  return [AI_THREADS_KEY, threadId];
}

export interface AiThread {
  id: string;
  title: string;
  user_id: number;
  created_at: string;
  updated_at: string;
}

export interface NewAiThread {
  id: string;
  title: string;
}

export interface AiThreadsResponse extends PagedResponse {
  aiThreads: AiThread[];
}

export async function getAiThreads({ page, perPage }: PageParams): Promise<AiThreadsResponse> {
  const resp = await request(
    'get',
    api_ai_threads_path({
      page,
      per_page: perPage,
    })
  );
  return resp;
}

export async function createAiThread(values: NewAiThread): Promise<AiThread> {
  const resp = await request('post', api_ai_threads_path(), { ai_thread: values });
  return resp;
}

export async function updateAiThread(
  threadId: string,
  values: Partial<NewAiThread>
): Promise<AiThread> {
  const resp = await request('patch', api_ai_thread_path(threadId), { ai_thread: values });
  return resp;
}

export async function deleteAiThread(threadId: string): Promise<{ message: string }> {
  const resp = await request('delete', api_ai_thread_path(threadId));
  return resp;
}
